export default __webpack_public_path__ + "static/media/151-indoor.118c1523.png";